import React, { useEffect,useState } from 'react';


const MessageA15 = (props) => {

    // useEffect(() => {
    //     const data= props.handleInputValue();
    //     console.log("submitprops",props,data)
    // },[props.handleInputValue])



    return(
        <div style={{marginTop:'10px'}}>
            <span className={!props.disable ? "chat-label action-tab ":"chat-labelnohover action-tab"} style={{color:props.disable && 'grey'}} id="main-tab1" onClick={()=>{
                const data = JSON.parse(localStorage.getItem("inputValue"))
                // console.log("Input--->", data);
                if(!props.disable)
               { props.handleClick(props.item.code,data);
                props.setTextOnClick(props.item.text) }}}>{props.item.text || "Submit"}</span>
            </div>
    )
}


export default MessageA15;